<template>
  <div class="relative flex flex-col">
    <div v-if="label">
      <label
        :for="label"
        class="text-text-primary text-sm font-medium dark:text-text-primary-dark"
        :class="[labelClass, allowLabelWrap ? '' : 'label-wrapper']"
      >
        {{ label }}
        <span v-if="required" class="ml-1">
          (Obligatorio)<span class="text-text-error">*</span>
        </span>
      </label>
    </div>
     <InputNumber
        v-if="isCurrency"
        :placeholder="placeholder"
        :minFractionDigits="minFractionDigits"
        :maxFractionDigits="maxFractionDigits"
        mode="currency"
        :currency="currency"
        :locale="getLocale(currency)"
        :inputClass="'w-full cursor-pointer dark:!bg-surface-primary dark:!text-text-primary-dark ' + inputClass"
        :modelValue="modelValue"
        @input="onInputNumber"
        :fluid="fluid"
      />
      <div class="mt-1 ">
        <InputNumber
          v-if="!isCurrency"
          :disabled="disabled"
          :inputClass="'cursor-pointer dark:!bg-surface-primary dark:!text-text-primary-dark' + inputClass"
          :modelValue="modelValue"
          @update:modelValue="$emit('update:modelValue', $event)"
          :inputId="inputId"
          :minFractionDigits="minFractionDigits"
          :maxFractionDigits="maxFractionDigits"
          :fluid="fluid"
          :placeholder="placeholder"
          v-bind="$attrs"
        />
      </div>
  </div>
</template>


<script setup lang="ts">
import InputNumber from "primevue/inputnumber";

const props = defineProps({
  modelValue: { type: [Number, null], default: null },
  disabled: { type: Boolean, default: false },
  inputClass: { type: String, default: "" },
  minFractionDigits: { type: Number, default: 0 },
  maxFractionDigits: { type: Number, default: 5 },
  fluid: { type: Boolean, default: false },
  size: { type: String, default: "medium" },
  variant: { type: String, default: "default" },
  inputId: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  label: { type: String, default: "" },
  required: { type: Boolean, default: false },
  labelClass: { type: String, default: "" },
  allowLabelWrap: { type: Boolean, default: false },
  isCurrency: { type: Boolean, default: false },
  currency: { type: String, default: "" }
});

const emit = defineEmits<{
  "update:modelValue": [value: number | null];
}>();

function onInputNumber(event: any) {
  const value = event && typeof event.value === "number" ? event.value : null;
  emit("update:modelValue", value);
}

function getLocale(currency: string) {
  const locales: Record<string, string> = {
    USD: "en-US",
    CLP: "es-CL",
    EUR: "en-EN"
  };
  return locales[currency];  
}
</script>